<template>
  <div>
    <breadcrumbs v-if="adventure" :adventure="adventure" :adventureId="adventureId" :chapter="selectedChapter" :chapterId="selectedChapterId"></breadcrumbs>
    <section id="page-adventure-edit" class="mdl-grid adv-content" style="background-color: white; margin-top:20px;" >
      <div v-if="adventure" class="mdl-grid mdl-cell--12-col">
        <div class="mdl-cell--6-col mdl-cell--12-col-tablet" >
          <dropzone-firebase v-if="user" :folder="user.uid+'/'+adventureId" file-name="bg" :bg-image='adventure.cover' @upload='coverUpdate'></dropzone-firebase>
        </div>
        <div class="mdl-cell--6-col mdl-cell--12-col-tablet mdl-grid " >
          <div class="mdl-cell--12-col-tablet mdl-grid" style="background-color: white; text-align: left;">
            <h5 class="mdl-cell--12-col">Edit Adventure</h5>
            <div :class="{'is-dirty': adventure.name}" class="mdl-cell mdl-cell--12-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-cell--12-col">
              <input class="mdl-textfield__input" type="text" id="sample1" :value="adventure.name" @input='updateName'>
              <label class="mdl-textfield__label" for="sample1">Name...</label>
            </div>
            <div :class="{'is-dirty': adventure.description}"  class="mdl-cell mdl-cell--12-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-cell--12-col">
              <textarea class="mdl-textfield__input" type="text" rows= "4" id="sample5" :value="adventure.description" @input='updateDescription'></textarea>
              <label class="mdl-textfield__label" for="sample5">Description...</label>
            </div>
            <h5 class="mdl-cell--12-col">Chapters</h5>
            <router-link :to="('/editor/'+adventureId+'/chapters')" style="margin: 5px" class="mdl-cell mdl-cell--6-col mdl-button mdl-button--raised  mdl-button--colored mdl-js-button mdl-js-ripple-effect">
              <i class="material-icons">collections_bookmark</i> Edit Chapters</router-link>
            <router-link :to="('/editor/play/'+adventureId)" style="margin: 5px" class="mdl-cell mdl-cell--6-col mdl-button mdl-button--raised  mdl-button--colored mdl-js-button mdl-js-ripple-effect">
              <i class="material-icons">play_arrow</i> Play Adventure</router-link>
            <button @click="showDialog('deleteAdventure')" style="margin: 5px; " class="mdl-cell mdl-cell--6-col mdl-button mdl-button--raised mdl-js-button mdl-js-ripple-effect" >
              <i class="material-icons">delete</i>Delete Adventure</button>
          </div>
        </div>        
      </div>
      <div class="mdl-grid mdl-cell--12-col" v-else>
        <h3 class="mdl-cell--12-col" style="text-align: left;">Adventure Deleted</h3>
        <router-link :to="('/editor/')" class="mdl-button mdl-button--raised  mdl-button--colored mdl-js-button mdl-js-ripple-effect"><i class="material-icons">keyboard_arrow_left</i>Back to My Adventures</router-link>
      </div>
    </section>
    <dialog class="mdl-dialog deleteAdventure">
    <div class="mdl-dialog__title">Delete this adventure</div>
      <div class="mdl-dialog__content">
        <p>
          Are you sure you want to delete this adventure? <br />
          This action cannot be undone.
        </p>
      </div>
      <div class="mdl-dialog__actions mdl-dialog__actions">
        <button type="button" class="mdl-button" @click="deleteAdventure">DELETE</button>
        <button type="button" class="mdl-button close">CANCEL</button>
      </div>
    </dialog>

  </div>
</template>

<script>
  import Vue from 'vue'
  import Sortable from 'vue-sortable';
  import DropzoneFirebase from './DropzoneFirebase.vue'
  import Breadcrumbs from './Breadcrumbs.vue'
  
  Vue.use(Sortable)

  var sectionAdventureEdit

  export default{ 
    components: {
        DropzoneFirebase,
        Breadcrumbs
    },
    data: ()=>({
        adventure: {},
        adventureId: "",
        advRef: {},
        advDetailsRef: {},
        user: null
    }),
    created() {
      sectionAdventureEdit = this;
      this.adventureId = this.$route.params.adventure;
      this.user = window.firebase.auth().currentUser;
      if(this.user) this.startSetup();
      window.firebase.auth().onAuthStateChanged((user) => {
        sectionAdventureEdit.user = user;
        if(sectionAdventureEdit.user)
        sectionAdventureEdit.startSetup();
      });
    },
    methods: {
      startSetup(){
        this.advRef = window.firebase.database().ref('adventures/'+this.adventureId);
        this.advDetailsRef = window.firebase.database().ref('adventureDetails/'+this.user.uid+'/'+this.adventureId);
        this.advDetailsRef.on('value', function(snapshot) {
          sectionAdventureEdit.adventure = snapshot.val();
        });
      },
      updateName(e) {
        this.advDetailsRef.child('name').set(event.target.value)
        this.advRef.child('name').set(event.target.value)
      },
      updateDescription(e) {
        this.advDetailsRef.child('description').set(event.target.value)
        this.advRef.child('description').set(event.target.value)
      },
      coverUpdate(value){
        this.advDetailsRef.child('cover').set(value)
        this.advRef.child('cover').set(value)
      },
      showDialog(dialogId){
        var dialog = document.querySelector('dialog.'+dialogId);
        if (!dialog.showModal) {
          dialogPolyfill.registerDialog(dialog);
        }
        dialog.showModal();
        if(!dialog.listened)
        dialog.querySelector('.close').addEventListener('click', function() {
          dialog.close();
        });
        dialog.listened = true;
      },
      deleteAdventure(){
        this.advRef.once('value', function(snapshot) {
          var adventure = snapshot.val();
          if(adventure){
            if(adventure.chapters){
              for(var chpId in adventure.chapters){
                for(var stgId in adventure.chapters[chpId].stages){
                  if(adventure.chapters[chpId].stages[stgId].bg){
                    window.firebase.storage().ref(sectionAdventureEdit.user.uid+"/"+sectionAdventureEdit.adventureId+"/"+chpId+"/stages/"+stgId+".png").delete();
                  }
                }
                for(var objId in adventure.chapters[chpId].objects){
                  if(adventure.chapters[chpId].objects[objId].bg){
                    window.firebase.storage().ref(sectionAdventureEdit.user.uid+"/"+sectionAdventureEdit.adventureId+"/"+chpId+"/objects/"+objId+".png").delete();
                  }
                }
              }
            }
            if(adventure.cover){
              window.firebase.storage().ref(sectionAdventureEdit.user.uid+"/"+sectionAdventureEdit.adventureId+"/bg.png").delete();
            }
          }
          sectionAdventureEdit.adventure = {};
          sectionAdventureEdit.advRef.set(null);
          sectionAdventureEdit.advDetailsRef.set(null);

          var dialog = document.querySelector('dialog.deleteAdventure');
          dialog.close();
        });
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// SectionAdventureEdit.vue?3e659543